import { useCallback, useEffect, useState } from 'react';
import { HostPort } from '../models/api/codegen/code';
import { useSelector } from 'react-redux';
import { StoreType } from '../store/spirs/types';

export interface SlideItem {
    href: string;
    text: string;
    imgPath: string;
}

export const useBanners = () => {
    const bannerHostPort = useSelector<StoreType, HostPort | null>(
        state => state.appSettings.bannerHostPort
    );
    const [slides, setSlides] = useState<SlideItem[]>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchSlides = useCallback(async () => {
        if (!bannerHostPort?.host || !bannerHostPort?.port) {
            setError('Invalid host or port configuration');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const url = `https://${bannerHostPort.host}:${bannerHostPort.port}/banners/slides.json`;
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Response code is ${response.status}`);
            }

            const json: SlideItem[] = await response.json();

            const slidesWithFullPaths = json.map(el => ({
                ...el,
                imgPath: `https://${bannerHostPort.host}:${bannerHostPort.port}${el.imgPath}`
            }));

            setSlides(slidesWithFullPaths);
        } catch (err) {
            const errorMessage =
                err instanceof Error ? err.message : 'Unknown error';
            setError(errorMessage);
            console.warn('Failed to fetch slides:', errorMessage);
        } finally {
            setLoading(false);
        }
    }, [bannerHostPort]);

    useEffect(() => {
        if (bannerHostPort?.host && bannerHostPort?.port) {
            fetchSlides();
        }
    }, [bannerHostPort, fetchSlides]);

    return { slides, loading, error, refetch: fetchSlides };
};
